import { render, staticRenderFns } from "./completePurchasesDialog.vue?vue&type=template&id=d893cfa8&scoped=true"
import script from "./completePurchasesDialog.vue?vue&type=script&lang=js"
export * from "./completePurchasesDialog.vue?vue&type=script&lang=js"
import style0 from "./completePurchasesDialog.vue?vue&type=style&index=0&id=d893cfa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d893cfa8",
  null
  
)

export default component.exports